import React from 'react';
import { rootRoute } from '@/modules/core/root/route';
import { createRoute } from '@tanstack/react-router';

export const storeRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'store-redirect',
  component: React.lazy(async () => await import('@/components/StoreRedirect')),
  wrapInSuspense: true,
});
